import { useEffect } from "react";
import { Link } from "react-router-dom";
import { track } from "../lib/analytics";
import { useMe } from "../state";

export function BuySuccess() {
  const { refresh } = useMe();
  useEffect(() => { track("checkout_success"); }, []);

  // Webhook usually arrives within a second; refresh a few times to catch it.
  useEffect(() => {
    let cancelled = false;
    const tick = async (n: number) => {
      if (cancelled || n === 0) return;
      await refresh();
      setTimeout(() => tick(n - 1), 2000);
    };
    tick(6);
    return () => { cancelled = true; };
  }, [refresh]);

  return (
    <div className="mt-16 text-center">
      <div className="font-display font-black text-4xl mb-3">tokens on the way 🎟</div>
      <p className="text-ink-soft mb-8">your balance updates as soon as stripe confirms.</p>
      <div className="flex justify-center gap-3">
        <Link to="/" className="btn-primary">make one live</Link>
        <Link to="/jobs" className="btn-ghost">my jobs</Link>
      </div>
    </div>
  );
}
